import { gql } from "@apollo/client";

const SAVE_VISITA_FONOAUDIOLOGO = gql`
    mutation saveVisitaDisfagiaFonoaudiologo($input: AddVisitaDisfagiaFonoInput!){
     saveVisitaDisfagiaFonoaudiologo(input: $input) {
            idVisitaDisfagia
            idVisita
        }
    }
`;

export default SAVE_VISITA_FONOAUDIOLOGO;

export const adaptAddVisitaDisfagiaFonoInput = (data) => ({
  idVisitaDisfagia: data?.idVisitaDisfagia,
  videodeglucion: !!data?.videodeglucion,
  actividadMotora: !!data?.actividadMotora,
  controlCefalico: !!data?.controlCefalico,
  idComboRIValorPostural: data?.idComboRIValorPostural,
  idComboRIValorDenticion: data?.idComboRIValorDenticion,
  idComboRIValorProtesis: data?.idComboRIValorProtesis,
  nadaPorBoca: !!data?.nadaPorBoca,
  justificaNadaPorBoca: data?.justificaNadaPorBoca,
  idComboVisitaValorTipoDieta: data?.idComboVisitaValorTipoDieta,
  idComboRIValorHidratacion: data?.idComboRIValorHidratacion,
  complicaciones: data?.complicaciones,
  idVisita: data?.idVisita,
  idComboVisitaValorTipoRehabilitacion: data?.idComboVisitaValorTipoRehabilitacion,
  examenClinico: data?.examenClinico,
  maniobrasPosturales: !!data?.maniobrasPosturales,
  indicacion: data?.indicacion
});